export default "__VITE_ASSET__BwN9I4xi__"